module.exports = __webpack_public_path__ + "assets/img/twin-centrifuge-stand-on-three-sided-tank.0d638f15.jpg";